
import { UseFormRegister, UseFormWatch, UseFormSetValue } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ImageUpload from "./ImageUpload";
import GalleryUpload from "./GalleryUpload";
import { ProductFormData } from "@/utils/productHelpers";

interface MediaTabProps {
  register: UseFormRegister<ProductFormData>;
  watch: UseFormWatch<ProductFormData>;
  setValue: UseFormSetValue<ProductFormData>;
  galleryImages: string[];
  onGalleryImagesChange: (images: string[]) => void;
}

const MediaTab = ({ register, watch, setValue, galleryImages, onGalleryImagesChange }: MediaTabProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-foreground">Primary Image</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="image_url">Image URL</Label>
            <Input
              id="image_url"
              {...register("image_url")}
              className="mt-1"
              placeholder="https://example.com/image.jpg"
            />
          </div>
          
          <ImageUpload
            currentImage={watch("image_url")}
            onImageUploaded={(url) => setValue("image_url", url)}
          />
        </CardContent>
      </Card>

      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-foreground">Image Gallery</CardTitle>
        </CardHeader>
        <CardContent>
          <GalleryUpload
            images={galleryImages}
            onImagesChange={onGalleryImagesChange}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default MediaTab;
